export function GetBreedClassNo(BreedClass) {
    let result = '';
    switch (BreedClass) {
        case 'หลัก':
            result = "00";
            break;
        case 'ขยาย':
            result = "01";
            break;
        case 'จำหน่าย':
            result = "02";
            break;
    }

    return result;
}
export function getStatusName(Status) {
    let _status = '';
    switch (Status) {
        case 'Y':
            return _status = "ปกติ";
        case 'N':
            return _status = "ยกเลิก";
        case 'D':
            return _status = "เสร็จสิ้น";
        case 'C':
            return _status = "ปิด";
    }
}

export function GetSeasonNo(season) {
    let result = '';
    switch (season) {
        case 'ฝน':
            result = "01";
            break;
        case 'แล้ง':
            result = "02";
            break;
    }

    return result;
}
export function CalQtySack(option2, qty) {
    let _qty = qty || 0;
    if (option2?.includes('หลัก')) {
        return Math.ceil(parseInt(_qty) / 20);
    } else {
        return Math.ceil(parseInt(_qty) / 25);
    }
}
export function checkReserveCenter(reserve) {
    const ReserveNoCenter = reserve ? reserve?.ReserveNo.split('-') : [];
    return ReserveNoCenter.length > 1 ? true : false
}
export const StockStatus = {
    Draft: 'D', // แบบร่าง
    Waiting: 'W',  // รออนุมัติ
    Finish: 'F',   // อนุมัติ
    Remove: 'R', // ลบ
    Close: 'C',
    Active: 'Y', // บันทึก
    Inactive: 'N'  // ยกเลิก
}

// export const getZoneFromBranchs = async (BranchNo) => {
//     try {
//         const res = await this.api.getZones(BranchNo);
//         if (res.status) {
//             return res.result;
//         }
//         else {
//             throw new Error(res.code);
//         }
//     } catch (error) {
//         console.error(error);
//         const errorMassage = await this.translate.get('Msg_Err.SOMETHING_WRONGG').toPromise();
//         throw new Error(errorMassage);
//     }
// }